import { FirestoreDataConverter, DocumentData, QueryDocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export const INSTAGRAM_GRAPH_API_PATH = "instagram_graph_api";
export const INSTAGRAM_ACCOUNT_PATH = "account";

export type InstagramGraphAPIType = {
  id: string;
  uid: string;
  instagram_access_token: string;
  instagram_business_id: string;
  facebook_page_name: string;
  facebook_page_category: string;
  facebook_page_auth_tasks: string[];
  instagram_account_name: string;
  instagram_display_name: string;
  instagram_biography: string;
  instagram_profile_picture_url: string;
  instagram_followers_count: number;
  instagram_follows_count: number;
  instagram_media_count: number;
  createTime: number;
  updateTime: number;
};

export const instagramGraphAPIConverter: FirestoreDataConverter<InstagramGraphAPIType> = {
  toFirestore(params: InstagramGraphAPIType): DocumentData {
    return {
      id: params.id,
      uid: params.uid,
      instagram_access_token: params.instagram_access_token,
      instagram_business_id: params.instagram_business_id,
      facebook_page_name: params.facebook_page_name,
      facebook_page_category: params.facebook_page_category,
      facebook_page_auth_tasks: params.facebook_page_auth_tasks,
      instagram_account_name: params.instagram_account_name,
      instagram_display_name: params.instagram_display_name,
      instagram_biography: params.instagram_biography,
      instagram_profile_picture_url: params.instagram_profile_picture_url,
      instagram_followers_count: params.instagram_followers_count,
      instagram_follows_count: params.instagram_follows_count,
      instagram_media_count: params.instagram_media_count,

      createTime: params.createTime,
      updateTime: params.updateTime,
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): InstagramGraphAPIType {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      uid: data.uid,
      instagram_access_token: data.instagram_access_token,
      instagram_business_id: data.instagram_business_id,
      facebook_page_name: data.facebook_page_name,
      facebook_page_category: data.facebook_page_category,
      facebook_page_auth_tasks: data.facebook_page_auth_tasks,
      instagram_account_name: data.instagram_account_name,
      instagram_display_name: data.instagram_display_name,
      instagram_biography: data.instagram_biography,
      instagram_profile_picture_url: data.instagram_profile_picture_url,
      instagram_followers_count: data.instagram_followers_count,
      instagram_follows_count: data.instagram_follows_count,
      instagram_media_count: data.instagram_media_count,
      createTime: data.createTime,
      updateTime: data.updateTime,
    };
  },
};
